/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgHvt48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M1.478 32.447s5.43-3.95 7.639-5.555a1.999 1.999 0 011.961-.222l7.04 3.003c.726.31 1.566.164 2.145-.373l6.119-5.678M34.66 21.469l6.881.889'
      />
      <path fill='currentColor' d='M30 23a2 2 0 100-4 2 2 0 000 4z' />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M41.845 25.364V8a4 4 0 00-4-4H5.5a4 4 0 00-4 4v26.914a4 4 0 004 4h20.052'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M41.748 40.825l4.752 5.072'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M36.013 42.57c4.425 0 8.012-3.598 8.012-8.035 0-4.438-3.587-8.035-8.012-8.035-4.426 0-8.013 3.597-8.013 8.035 0 4.437 3.587 8.034 8.013 8.034z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.483 10.81H24.5M7.483 15.466H12'
      />
    </svg>
  );
}

export default SvgHvt48;
